var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_247",
    "data-name": "Group 247",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M12.7,4.653v.52a2.9,2.9,0,0,1,.883-.2,1.016,1.016,0,0,1,.642.19,1.084,1.084,0,0,1,.334.359.8.8,0,0,1-.058.918,1.017,1.017,0,0,1-.426.363q-.471.214-.611-.231A.606.606,0,0,0,12.7,6.13v2a8.474,8.474,0,0,1,.949-.146,1.224,1.224,0,0,1,.633.1.941.941,0,0,1,.459.433,1.541,1.541,0,0,1,.162.737,2.822,2.822,0,0,1-.258,1.136,3.9,3.9,0,0,1-.758,1.119,4.865,4.865,0,0,1-1.187.913v1.2a1.43,1.43,0,0,1-.055.44.442.442,0,0,1-.244.245c-.115.054-.195.057-.242.009a.434.434,0,0,1-.07-.293v-1.3a2.794,2.794,0,0,1-.983.195,1.345,1.345,0,0,1-.7-.185,1.116,1.116,0,0,1-.416-.446,1.265,1.265,0,0,1-.135-.579.888.888,0,0,1,.18-.492,1.072,1.072,0,0,1,.451-.382.608.608,0,0,1,.365-.064.28.28,0,0,1,.207.19,3.841,3.841,0,0,0,.225.5.62.62,0,0,0,.291.248.927.927,0,0,0,.518.021V9.493a4.653,4.653,0,0,1-1.078.108.992.992,0,0,1-.7-.309,1.319,1.319,0,0,1-.269-.922,2.751,2.751,0,0,1,.527-1.587,4.431,4.431,0,0,1,1.522-1.32v-.51a.549.549,0,0,1,.3-.548c.205-.1.309-.015.309.248m-.611,3.59V6.4a3.263,3.263,0,0,0-.629.614,1.124,1.124,0,0,0-.227.7c0,.253.071.413.211.477a1.3,1.3,0,0,0,.645.05M12.7,9.381v2.107a2.548,2.548,0,0,0,.75-.741,1.511,1.511,0,0,0,.266-.806c0-.278-.086-.455-.258-.528a1.458,1.458,0,0,0-.758-.032",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M4.891,18.732A7.789,7.789,0,0,1,.208,17.177.5.5,0,0,1,0,16.771v-13a.5.5,0,0,1,.272-.446.507.507,0,0,1,.52.04,6.825,6.825,0,0,0,4.1,1.367c2.382,0,4.867-1.179,7.27-2.318C14.665,1.228,17.252,0,19.859,0a7.787,7.787,0,0,1,4.683,1.555.5.5,0,0,1,.208.406v13a.5.5,0,0,1-.272.445.5.5,0,0,1-.52-.039A6.818,6.818,0,0,0,19.859,14c-2.382,0-4.866,1.179-7.269,2.318-2.5,1.186-5.091,2.413-7.7,2.414ZM1,16.51a6.767,6.767,0,0,0,3.891,1.222h0c2.382,0,4.867-1.179,7.269-2.318,2.5-1.186,5.091-2.414,7.7-2.414a7.633,7.633,0,0,1,3.891,1.043V2.222A6.765,6.765,0,0,0,19.859,1c-2.381,0-4.866,1.179-7.269,2.318C10.087,4.5,7.5,5.732,4.892,5.732A7.637,7.637,0,0,1,1,4.689Z",
    fill: "#4eaaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M4.884,20.86A7.794,7.794,0,0,1,.208,19.3a.5.5,0,0,1,.584-.812c3.719,2.677,7.435.915,11.369-.95,4.023-1.908,8.183-3.879,12.381-.86a.5.5,0,0,1-.584.813c-3.719-2.676-7.434-.915-11.368.95-2.523,1.2-5.1,2.418-7.706,2.418",
    fill: "#4eaaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M4.886,8.418a7.8,7.8,0,0,1-1.615-.166.5.5,0,0,1,.207-.979A9.361,9.361,0,0,0,8.762,6.6a.5.5,0,1,1,.351.935,12.068,12.068,0,0,1-4.227.882",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M15.813,4.538a.5.5,0,0,1-.175-.969,10.3,10.3,0,0,1,5.841-.716.5.5,0,0,1-.207.979,9.38,9.38,0,0,0-5.284.675.513.513,0,0,1-.175.031",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M4.886,16.043a7.8,7.8,0,0,1-1.615-.166.5.5,0,0,1,.207-.979,9.361,9.361,0,0,0,5.284-.672.5.5,0,1,1,.351.935,12.068,12.068,0,0,1-4.227.882",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M15.813,12.163a.5.5,0,0,1-.175-.969,10.308,10.308,0,0,1,5.841-.716.5.5,0,0,1-.207.979,9.38,9.38,0,0,0-5.284.675.513.513,0,0,1-.175.031",
    fill: "#0d292d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.364740452a53cc3cdb728d7c4ee2839c.svg";
export { ForwardRef as ReactComponent };